import { render, staticRenderFns } from "./OfficialAccount.vue?vue&type=template&id=22f566d9&scoped=true"
import script from "./OfficialAccount.vue?vue&type=script&lang=js"
export * from "./OfficialAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f566d9",
  null
  
)

export default component.exports